import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Clock, CalendarDays } from "lucide-react";
import { hasAdvanceServiceRule } from "@/utils/scheduleUtils";

export default function CheckoutScheduleSection({
  tc, isOpen, isTableOrder, schedule, onScheduleChange, getAvailableDates, getTimeSlots, restaurant,
}) {
  const dates = schedule.mode !== "disabled" ? getAvailableDates() : [];
  const showAsap = isOpen && schedule.mode !== "forced";
  const channel = restaurant?.__selected_order_type || "pickup";
  const hasAdvanceRule = hasAdvanceServiceRule(restaurant?.scheduling_config || {}, channel);
  const effectiveDate =
    schedule.mode !== "disabled" && schedule.date === "asap" && !showAsap && dates.length > 0
      ? dates[0].value
      : schedule.date;
  if (schedule.mode !== "disabled" && effectiveDate !== schedule.date) {
    setTimeout(() => onScheduleChange.date(effectiveDate), 0);
  }

  return (
    <>
      {!isOpen && !isTableOrder && (
        <div className="rounded-xl p-3 border border-amber-300 bg-amber-50" data-testid="closed-schedule-notice">
          <div className="flex items-center gap-2 mb-1">
            <Clock className="w-4 h-4 text-amber-600" />
            <span className="text-sm font-bold text-amber-800">Estamos fora do horario</span>
          </div>
          <p className="text-xs text-amber-700">Seu pedido sera agendado para o proximo horario disponivel. Selecione data e hora abaixo.</p>
          {restaurant?.business_hours?.length > 0 && (
            <div className="mt-2 text-[11px] text-amber-600 space-y-0.5">
              {restaurant.business_hours.filter(h => h.enabled).map(h => (
                <div key={h.day} className="flex gap-2">
                  <span className="font-semibold capitalize w-20">{h.day}</span>
                  <span>{(h.slots || []).map(s => `${s[0]}-${s[1]}`).join(", ")}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {schedule.mode === "forced" && isOpen && (
        <div className="rounded-xl p-3 border border-blue-200 bg-blue-50" data-testid="forced-schedule-notice">
          <div className="flex items-center gap-2">
            <CalendarDays className="w-4 h-4 text-blue-600" />
            <span className="text-sm font-bold text-blue-800">Apenas pedidos agendados</span>
          </div>
          <p className="text-xs text-blue-600 mt-1">Este restaurante trabalha com pedidos agendados. Selecione data e hora abaixo.</p>
        </div>
      )}

      {schedule.mode !== "disabled" && (
        <div>
          <Label className="text-xs font-semibold uppercase" style={{ color: tc.primary }}>Quando receber</Label>
          <div className="grid grid-cols-2 gap-2 mt-1.5">
            <Select value={effectiveDate} onValueChange={v => { onScheduleChange.date(v); if (v !== "asap") { const s = getTimeSlots(v); if (s.length > 0) onScheduleChange.time(s[0]); else onScheduleChange.time(""); } }}>
              <SelectTrigger className="bg-gray-50" data-testid="schedule-date"><SelectValue placeholder="Selecione" /></SelectTrigger>
              <SelectContent>
                {showAsap && <SelectItem value="asap">O mais rapido possivel</SelectItem>}
                {dates.map(d => <SelectItem key={d.value} value={d.value}>{d.label}</SelectItem>)}
              </SelectContent>
            </Select>
            {effectiveDate !== "asap" && (
              <Select value={schedule.time} onValueChange={onScheduleChange.time}>
                <SelectTrigger className="bg-gray-50" data-testid="schedule-time"><SelectValue placeholder="Horario" /></SelectTrigger>
                <SelectContent>{getTimeSlots(effectiveDate).map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
              </Select>
            )}
          </div>
        </div>
      )}
      {hasAdvanceRule && (
        <div className="text-xs rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-amber-900" data-testid="advance-period-notice">
          El servicio seleccionado requiere reserva o pedido programado con antelación en algunos turnos.
          Los horarios no disponibles se ocultan automáticamente; puede elegir la cena de hoy o el almuerzo del siguiente día disponible.
        </div>
      )}
      {schedule.mode === "disabled" && (
        <div className="text-xs text-gray-500 italic">Pedido sera processado imediatamente.</div>
      )}
    </>
  );
}
